import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import {
  appointmentRepository,
  Appointment,
} from "../../../../api/appointmentRepository";

interface RescheduleAppointmentProps {
  appointmentId: string;
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const RescheduleAppointment = ({
  appointmentId,
  isOpen,
  onClose,
  onSuccess,
}: RescheduleAppointmentProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [appointment, setAppointment] = useState<Appointment | null>(null);
  const [newDate, setNewDate] = useState("");
const inputBg = useColorModeValue("white", "gray.700");
const inputColor = useColorModeValue("black", "white");
const borderColor = useColorModeValue("gray.300", "gray.600");
  // Format min datetime-local to block past selections
  const formatMinDate = () => {
    const now = new Date();
    now.setSeconds(0, 0);
    return now.toISOString().slice(0, 16);
  };

  // Load appointment when modal opens
  useEffect(() => {
    if (!appointmentId || !isOpen) return;

    const fetch = async () => {
      try {
        const data = await appointmentRepository.getappointmentById(
          appointmentId
        );
        setAppointment(data);
        const formatted =
          data.scheduledDate?.split("T")[0] || "";
        setNewDate(formatted);
      } catch (err) {
      }
    };

    fetch();
  }, [appointmentId, isOpen]);

  const handleSave = async () => {
    if (!appointment) return;

    setLoading(true);

    try {
      // Convert datetime-local → ISO format
      const isoDate = new Date(newDate).toISOString();

      // Send only scheduledDate — backend PATCH requires this
      await appointmentRepository.rescheduleAppointment(
        appointment.id,
        isoDate
      );

      toast({
        title: "Appointment Rescheduled",
        description: "The appointment date has been successfully updated.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      onClose();
      onSuccess?.();
    } catch (error) {
      toast({
        title: "Error",
        description: "Unable to reschedule appointment.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
    >
      <AlertDialogOverlay>
        <Flex h="100vh" w="100%" justify="center" align="center">
          <AlertDialogContent p={6} borderRadius="xl" maxW="400px">
            <AlertDialogHeader fontWeight="bold">
              Reschedule Appointment
            </AlertDialogHeader>

            <AlertDialogBody>
              <FormControl>
                <FormLabel>New Appointment Date</FormLabel>
                <Input
                  type="date"
              //  type="datetime-local"
                  value={newDate}
                  bg={inputBg}
                  color={inputColor}
                  borderColor={borderColor}
                  min={
                    appointment?.scheduledDate
                      ? new Date(
                          new Date(appointment.scheduledDate).setDate(
                            new Date(appointment.scheduledDate).getDate() + 1
                          )
                        )
                          .toISOString()
                          .split("T")[0]
                      : ""
                  }
                  onChange={(e) => setNewDate(e.target.value)}
                />
              </FormControl>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose} variant="ghost">
                Cancel
              </Button>
              <Button
                colorScheme="blue"
                ml={3}
                isLoading={loading}
                onClick={handleSave}
              >
                Save
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </Flex>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default RescheduleAppointment;
